<template>
    <div>
        <a class="nav-link active hoverito" :href="`#${menu.id}`" data-toggle="collapse" role="button" :aria-expanded="menu.show" :aria-controls="`${menu.id}`"  @click="actualizar_menu(menu);menu.show=!menu.show">
            <i :class="`${menu.icono} text-primary`"></i>
            <span class="nav-link-text">{{menu.texto}}</span>
        </a>
        <div v-bind:class="{'collapse':true,'show':menu.show?true:false,'collapsing':menu.show}" :id="`${menu.id}`">
            <ul class="nav nav-sm flex-column">
                <li class="nav-item" v-for="sub in menu.submenus" :key="sub.id">
                    <router-link v-bind:class="{'nav-link hoverito':true,'activito':sub.activo}" :to="{name:sub.ruta}" v-on:click.native="actualizar_menu(sub)">
                        <span class="sidenav-mini-icon">  </span>
                        <span class="sidenav-normal"> <i :class="`${sub.icono} text-primary`"></i> {{sub.texto}} </span>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapState,mapActions } from 'vuex';
export default {
    props:['menu'],
    methods:{
        ...mapActions(['actualizar_menu'])
    },
}
</script>
<style>
.activito {
   background-color: #c6cfe6;
  color: #fff;
}

span.sidenav-mini-icon {
    width: 20px !important;
}
</style>